import envs from './envs';

export const getEnvironment = (): keyof typeof envs => {
  const { hostname } = document.location;
  if (hostname.includes('app.')) return 'production';
  if (hostname.includes('stage.')) return 'staging';
  if (hostname.includes('app-test.')) return 'testing';
  if (hostname.includes('qa.')) return 'qa';
  if (hostname.includes('local-app.')) return 'localhost';
  return 'localhost';
};

export const isProduction = () => getEnvironment() === 'production';
export const isDevelopment = () => getEnvironment() === 'localhost';

const getConfig = () => envs[getEnvironment()];

export default getConfig();
